import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import PostCard from "@/pages/blog/components/PostCard";
import { getFeaturedPosts } from "@/pages/blog/blogData";

export default function FeaturedPosts() {
  const featured = getFeaturedPosts(6);
  const [lead, ...rest] = featured;

  if (!lead) return null;

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading
            align="left"
            badge="Conteúdos em destaque"
            badgeIcon="ri-star-line"
            title="Conteúdos em destaque"
            description="Os artigos que melhor resumem o que fazemos e que mais ajudam quem está começando ou evoluindo um projeto na internet."
          />
          <Link
            to="/blog/busca?q="
            className="hidden whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:inline-flex"
          >
            Ver todos os artigos
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5">
          <Reveal>
            <PostCard post={lead} variant="featured" />
          </Reveal>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {rest.slice(0, 5).map((post, index) => (
              <Reveal key={post.slug} delay={index * 50}>
                <PostCard post={post} />
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}